import { render, staticRenderFns } from "./ClientDialog.vue?vue&type=template&id=efce02ce"
import script from "./ClientDialog.vue?vue&type=script&lang=js"
export * from "./ClientDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports